import { Component } from '@angular/core';
import { TextService } from './services/text.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'web';

  text: any = {};

  constructor(
    private textService: TextService,
  ) {
    this.textService.setLocale('es');
  }


}
